/**
 * Copy Text to Clipboard
 *
 * @param {string} text Text to copy
 */
export function copyTextToClipboard(text) {
  const dummy = document.createElement('textarea');
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
}

/**
 * Copy Element Text to Clipboard
 *
 *  @param {Element} elem Element where to copy text
 */
export function copyElemToClipboard(elem) {
  const range = document.createRange();
  range.selectNode(elem);
  window.getSelection().removeAllRanges(); // clear current selection
  window.getSelection().addRange(range); // to select text
  document.execCommand('copy');
  window.getSelection().removeAllRanges();// to deselect
}
